export default __webpack_public_path__ + "beep.c8a11ba27dbf1c12e9188b8c1f55774c.mp3";